import React from "react";
import MessageView from "./message";
import { makeStyles } from "@material-ui/core";
import { useChannelContext } from "@sendbird/uikit-react/Channel/context";
import { useRef } from "react";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  messageListParent: { height: "calc(100vh - 262px)", overflow: "auto" },
  messageListEmpty: { textAlign: "center", color: "var(--darkbluecolortwo)" },
}));

const MessageListParent = ({ profile, isAdmin }) => {
  const channelState = useChannelContext();
  const { allMessages } = channelState;

  const classes = useStyles();

  // Function to scroll to the bottom of the messages
  const scrollToBottom = () => {
    channelState.scrollRef.current.scrollTop =
      channelState.scrollRef.current.scrollHeight;
  };

  const previousDate = useRef();

  // Effect to scroll to the bottom whenever new messages are added
  useEffect(() => {
    if (
      channelState?.currentGroupChannel?.lastMessage?.sender.userId == profile
    ) {
      scrollToBottom();
    }
  }, [allMessages]);

  return (
    <div className={classes.messageListParent} ref={channelState.scrollRef}>
      {allMessages.map((message) => (
        <MessageView
          messageObj={message}
          key={message.messageId}
          message={{ text: message.message, date: message.createdAt }}
          isDoctorsMessage={message.sender?.userId != profile}
          previousDate={previousDate}
          isFile={message.messageType === "file"}
          url={message.plainUrl}
          isAdmin={isAdmin}
        />
      ))}
    </div>
  );
};

export default MessageListParent;
